/**
 * Created by alvinoktavianus on 6/21/17.
 */

import { MOKA_COUPON_BILLING_API } from '../constants';

export const VERIFY_COUPON = coupon =>
  `${MOKA_COUPON_BILLING_API}/v1/coupons/${coupon}/verify`;
export const VERIFY_COUPON_V2 = coupon =>
  `${MOKA_COUPON_BILLING_API}/v2/coupons/${coupon}/verify`;
